import Image from 'next/image'
import { BidftaPlusHero } from '@components/BidftaPlus/BidftaPlusHero'
import { BidftaPlusBenefits } from '@components/BidftaPlus/BidftaPlusBenefits'
import MainLayout from '@components/MainLayout/MainLayout'
import getAuctions from 'api/getAuctions'
import BidAuctionCarousel from '@components/BidAuctionCarousel/BidAuctionCarousel'

export async function getServerSideProps(context: any) {
  const route = 'category'

  const auctions = await getAuctions(
    {
      ...context,
      query: { slug: 'members-only', pageId: '1' },
      resolvedUrl: '/category/members-only/1',
      params: { slug: 'members-only', pageId: '1' },
    },
    route
  )

  return { props: auctions }
}

export const BidPage = (props: any) => {
  return (
    <MainLayout
      title="BidFTA+ Subscription Perks"
      previewDescription="Get exclusive, members-only, perks when you subscribe to BidFTA+. From early pickup hours to members-only auctions all for $2.99/mo you won't regret it."
      hideOverflow={false}
    >
      <div className="bg-bidfta-blue-backdrop-dark">
        <div className="flex direction-row items-center justify-center bg-bidfta-blue-backdrop-light sm:h-26 md:h-38 md:bg-bidfta-blue-backdrop-dark text-bidfta-gray-white border-1 border-bidfta-gray-white">
          <div className="flex py-8">
            <Image
              src="/images/bidftaPlus/BidFTALogoWhite.svg"
              alt="Logo"
              width={300}
              height={88}
              className="w-60 h-15 lg:w-96 lg:h-24 xl:w-[430px] xl:h-[126px]"
            />
          </div>
        </div>
        <div className="flex flex-wrap">
          <BidftaPlusHero />
        </div>
        <div className="bg-bidfta-blue-backdrop-dark py-14">
          <BidftaPlusBenefits />
        </div>
        <div className="bg-bidfta-blue-light flex flex-col justify-center pl-9.5 pr-9.5 gap-y-8 md:gap-7 p-11 md:pt-7 md:pb-16">
          <div className="text-bidfta-gray-white font-extrabold text-center md:text-35 text-24 uppercase">
            <h4>BidFTA+ MEMBERS ONLY Auctions</h4>
          </div>
          {props?.initialAuctions?.length ? (
            <div className="flex items-center gap-3 ">
              <BidAuctionCarousel auctions={props?.initialAuctions} />
            </div>
          ) : (
            <p className="text-14 leading-6 md:text-18 my-4 font-medium text-center text-bidfta-gray-white">
              No Members Only auctions are currently scheduled, check back soon!
            </p>
          )}
        </div>
      </div>
    </MainLayout>
  )
}

export default BidPage
